import React from "react";
import { useState, useEffect } from "react";
import "./Modal.css";

function Modal({ alertMessage, setOpenAlert }) {
  return (
    <div className="modalBackground">
      <div className="modalContainer">
        {/* <div className="closeBtn">
          <button onClick={() => setOpenAlert(true)}>X</button>
        </div> */}

        <div className="title">
          <h1>Alert</h1>
        </div>
        <div className="body">
          <div className="messages">
            {alertMessage.map((message, index) => (
              <div className="alert" key={index}>
                {message}
              </div>
            ))}
          </div>
          <div className="footer">
            <button onClick={() => setOpenAlert(true)} id="cancelBtn">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Modal;
